import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { initialMarginSetupSlice } from './margin-setup.slice';
import { environment } from 'src/environments/environment';
import { MarginSetup } from '../../models/margin-setup.models';

export const MarginSetupStore = signalStore(
    { providedIn: 'root' },
    withState(initialMarginSetupSlice),
    withMethods((store) => ({
        updateMarginSetupFromData: (data: MarginSetup) => {
            patchState(store, { ...data });
        },
        updateMarginSetupField: (data: Partial<MarginSetup>) => {
            patchState(store, { ...data });
        },
        getState: () => store
    })),
    environment.storeWithDevTools('locums-margin-calculator-margin-setup-store')
);
